/** The queue on a phone: both sections as cards, filtered by the active tab. */
import { ReviewQueueMobileSection } from '../ReviewQueueMobileSection';
import type { ReviewQueueResponse } from '../reviewTypes';

export default function ReviewQueuePhoneBody({
  data,
  muted,
}: {
  data: ReviewQueueResponse;
  muted: boolean;
}) {
  return (
    <>
      <ReviewQueueMobileSection kind="booking" rows={data.bookings} muted={muted} />
      <ReviewQueueMobileSection kind="checkout" rows={data.checkouts} muted={muted} />
    </>
  );
}
